import api from './api';

export interface DiscountReason {
  id: number;
  name: string;
  is_active: boolean;
  created_at?: string;
}

export const discountReasonsService = {
  async list(onlyActive = true): Promise<DiscountReason[]> {
    const { data } = await api.get<DiscountReason[]>('/discount-reasons', {
      params: { only_active: onlyActive },
    });
    return data;
  },

  async create(name: string): Promise<DiscountReason> {
    const { data } = await api.post<DiscountReason>('/discount-reasons', { name });
    return data;
  },

  async update(id: number, cambios: { name?: string; is_active?: boolean }): Promise<DiscountReason> {
    const { data } = await api.patch<DiscountReason>(`/discount-reasons/${id}`, cambios);
    return data;
  },

  // Si el motivo ya se uso en una venta, el backend lo desactiva en vez de borrarlo:
  // esa venta quedaria sin poder explicar su descuento.
  async remove(id: number): Promise<void> {
    await api.delete(`/discount-reasons/${id}`);
  },
};
